import React from 'react';
import Icon from 'antd/lib/icon';
var selfStyles = require('./styles.scss');
var CardJoinEmpty = function () { return (React.createElement("div", { className: selfStyles.wrapper },
    React.createElement(Icon, { type: 'frown-o', className: selfStyles.icon }),
    React.createElement("p", null,
        "We did not find any events",
        React.createElement("br", null),
        "at that web address"))); };
export default CardJoinEmpty;



//////////////////
// WEBPACK FOOTER
// ./src/pages/PageWelcome/CardJoin/CardJoinEmpty.tsx
// module id = 840
// module chunks = 0